export class MimeTypeConfig {
  static zip = 'application/zip, application/octet-stream, application/x-compressed, application/x-zip-compressed, multipart/x-zip';
  static image = 'image/*';
}
